import { useLingui } from "@lingui/react";
import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

const KEY_POLOTNO_TEMPLATES = "polotno.templates";

type Params = Parameters<typeof ApiSmpArtGallery.Polotno.templates>[0];

export const useQueryPolotnoTemplates = (
  params?: Params,
  options?: Omit<
    UseInfiniteQueryOptions<
      Await<ReturnType<typeof ApiSmpArtGallery.Polotno.templates>>
    >,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    i18n: { locale },
  } = useLingui();

  params = {
    ...params,
    text_lang: locale,
  };

  return useInfiniteQuery<
    Await<ReturnType<typeof ApiSmpArtGallery.Polotno.templates>>
  >(
    [KEY_POLOTNO_TEMPLATES, params],
    ({ pageParam }) => ApiSmpArtGallery.Polotno.templates(pageParam || params),
    {
      ...options,
      getNextPageParam: (response) =>
        response.next
          ? Object.fromEntries(new URL(response.next).searchParams)
          : undefined,
    },
  );
};

useQueryPolotnoTemplates.INITIAL_PARAMS = {
  ordering: "-created_at",
  page_size: 100,
  tags__slug__all: [],
  text_lang: "ru",
} as Params;

useQueryPolotnoTemplates.KEY = KEY_POLOTNO_TEMPLATES;
